// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordProtection_container__377oV","contentBox":"PasswordProtection_contentBox__YJvXG","button":"PasswordProtection_button__2Z-O4"};